module.exports = __webpack_public_path__ + "static/media/App_paciente.f3611548.svg";